import React from 'react';
const { List, LinearProgress } = require("@material-ui/core");

const VirtuosoMUIComponents = {
  List: React.forwardRef((props, ref) => (
    <List ref={ref} {...props} dense />
  )),
  Item: React.forwardRef((props, ref) => (
    <div ref={ref} {...props} />
  )),
  
}

export { VirtuosoMUIComponents }